import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import MarketingNav from "@/components/MarketingNav";
import Footer from "@/components/Footer";
import { Loader2, BookOpen, ArrowRight } from "lucide-react";

export default function Atividades() {
  const navigate = useNavigate();
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/atividades/classes")
      .then((r) => setClasses(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-brand-bg flex flex-col">
      <MarketingNav />
      <main className="flex-1 max-w-6xl mx-auto w-full px-5 sm:px-8 py-12">
        <div className="flex items-center gap-3 text-brand-blue mb-3">
          <span className="w-11 h-11 rounded-2xl bg-brand-blue/10 flex items-center justify-center">
            <BookOpen className="w-6 h-6" />
          </span>
          <span className="text-sm font-semibold uppercase tracking-widest">Biblioteca escolar</span>
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl font-black text-brand-ink">Atividades por Turma</h1>
        <p className="mt-3 text-brand-muted max-w-2xl">
          Escolha a sua turma para acessar jogos, quizzes, links e materiais para download organizados pelos professores.
        </p>

        {loading ? (
          <div className="flex justify-center py-24">
            <Loader2 className="w-8 h-8 animate-spin text-brand-blue" />
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5" data-testid="classes-grid">
            {classes.map((c) => (
              <button
                key={c.slug}
                onClick={() => navigate(`/atividades/${c.slug}`)}
                data-testid={`class-card-${c.slug}`}
                className="group relative overflow-hidden rounded-3xl bg-white border border-slate-100 p-6 text-left shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              >
                <div
                  className="w-16 h-16 rounded-2xl flex items-center justify-center font-heading font-black text-2xl text-white shadow-lg"
                  style={{ backgroundColor: c.color || "#2563eb" }}
                >
                  {c.icon}
                </div>
                <h3 className="mt-5 font-heading font-bold text-lg text-brand-ink">{c.name}</h3>
                <span className="mt-2 inline-flex items-center gap-1 text-sm text-brand-blue font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                  Ver atividades <ArrowRight className="w-4 h-4" />
                </span>
              </button>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
